export default __webpack_public_path__ + "e6ab697.png";